import { gql } from "@apollo/client";

export const GET_SADDLE_DETAIL_QUERY = gql`
  query SaddleDetailQuery($id: ID!, $horseId: ID, $brandName: String) {
    listSaddleDetail(id: $id, horseId: $horseId, brandName: $brandName) {
      brandName
      variantId
      createdAt
      description
      discipline
      description
      gallery
      newOrUsed
      scannedFiles
      saddlefitSku
      discount
      photo
      pk
      price
      productTitle
      quantity
      score
      size
      sk
      status
      type
      updatedAt
      userId
      manufacturerMeasurements {
        barAngle
        gulletHeight
        gulletWidth
      }
      measurements {
        barAngle
        gulletHeight
        gulletWidth
      }
    }
  }
`;
